import { LAB_REPORT } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { ILabPartnerDetails } from "@/api_framework/api_modals/LabReport";
import { setLoading } from "@/app_redux/reducers/loading_reducer";

AxiosCurlirize(axios, () => {});

export const useLabPartnerListAPI = () => {
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();

  const [labList, setLablist] = useState<ILabPartnerDetails[] | []>();

  const configuration = useConfiguration();
  const execute = useCallback(async () => {
    dispatch(setLoading({ key: "isLabPartnerListInProgress", status: true }));
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      await axios
        .get(LAB_REPORT?.LAB_PARTNER_LIST?.baseURL, {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<any>) => {
          if (res.data.status === true) {
            setLablist(res.data.data);  
            dispatch(setLoading({ key: "isLabPartnerListInProgress", status: false }));
          } else {
            setLablist([]);
          }
        })
        .catch((e: AxiosError) => {
          setLablist([]);
          sendCurl(e.config["curlCommand"]);
          dispatch(setLoading({ key: "isLabPartnerListInProgress", status: false }));
        });
    } catch (e: any) {
      setLablist([]);
      dispatch(setLoading({ key: "isLabPartnerListInProgress", status: false }));
    }
  }, [dispatch]);
  return { execute, labList };
};
